/**
 * Generated from ch5_p12.fla
 */
export function ch5_p12(this: Ich5_p12) {
	const balloon = this.balloon;
	if (!balloon[0] && balloon.elementFactory) {
		balloon[0] = balloon.elementFactory(0,undefined);
	}
	if (balloon[0]) {
		ch5_p12_hh_ch5_72dpi_p012psdAssetch5_p12_balloon1.call(balloon[0] as Ich5_p12_hh_ch5_72dpi_p012psdAssetch5_p12_balloon1);
		balloon[0].x = 858;
		balloon[0].y = 528;
		balloon[0].width = 386.00;
		balloon[0].height = 178.00;
		balloon[0].alpha = 1;
		if (balloon[0].onLayout) balloon[0].onLayout();
	}
	if (!balloon[1] && balloon.elementFactory) {
		balloon[1] = balloon.elementFactory(1,undefined);
	}
	if (balloon[1]) {
		ch5_p12_hh_ch5_72dpi_p012psdAssetch5_p12_balloon2.call(balloon[1] as Ich5_p12_hh_ch5_72dpi_p012psdAssetch5_p12_balloon2);
		balloon[1].x = 1139.25;
		balloon[1].y = 448.5;
		balloon[1].width = 447.50;
		balloon[1].height = 612.00;
		balloon[1].alpha = 1;
		if (balloon[1].onLayout) balloon[1].onLayout();
	}
	if (!balloon[2] && balloon.elementFactory) {
		balloon[2] = balloon.elementFactory(2,undefined);
	}
	if (balloon[2]) {
		ch5_p12_hh_ch5_72dpi_p012psdAssetch5_p12_balloon3.call(balloon[2] as Ich5_p12_hh_ch5_72dpi_p012psdAssetch5_p12_balloon3);
		balloon[2].x = 658;
		balloon[2].y = 145.75;
		balloon[2].width = 222.00;
		balloon[2].height = 81.50;
		balloon[2].alpha = 1;
		if (balloon[2].onLayout) balloon[2].onLayout();
	}
	if (!balloon[3] && balloon.elementFactory) {
		balloon[3] = balloon.elementFactory(3,undefined);
	}
	if (balloon[3]) {
		ch5_p12_hh_ch5_72dpi_p012psdAssetch5_p12_balloon4.call(balloon[3] as Ich5_p12_hh_ch5_72dpi_p012psdAssetch5_p12_balloon4);
		balloon[3].x = 1538;
		balloon[3].y = 87.5;
		balloon[3].width = 252.00;
		balloon[3].height = 175.00;
		balloon[3].alpha = 1;
		if (balloon[3].onLayout) balloon[3].onLayout();
	}
	const bg = this.bg;
	ch5_p12_hh_ch5_72dpi_p012psdAssetch5_p12_bg.call(this.bg);
	bg.x = 832;
	bg.y = 384;
	bg.width = 1664.00;
	bg.height = 768.00;
	bg.alpha = 1.00;
	if (bg.onLayout) bg.onLayout();
	const hollyHorse = this.hollyHorse;
	ch5_p12_hh_ch5_72dpi_p012psdAssetch5_p12_hollyhorse.call(this.hollyHorse);
	hollyHorse.x = 849.5;
	hollyHorse.y = 768;
	hollyHorse.width = 932.00;
	hollyHorse.height = 684.50;
	hollyHorse.alpha = 1.00;
	if (hollyHorse.onLayout) hollyHorse.onLayout();
	const actionLines = this.actionLines;
	ch5_p12_hh_ch5_72dpi_p012psdAssetch5_p12_actionlines.call(this.actionLines);
	actionLines.x = 1282.25;
	actionLines.y = 386.5;
	actionLines.width = 652.50;
	actionLines.height = 763.00;
	actionLines.alpha = 1.00;
	if (actionLines.onLayout) actionLines.onLayout();
	const frameRight = this.frameRight;
	ch5_p12_hh_ch5_72dpi_p012psdAssetch5_p12_wcframeRframe.call(this.frameRight);
	frameRight.x = 1664;
	frameRight.y = 384;
	frameRight.width = 356.00;
	frameRight.height = 768.00;
	frameRight.alpha = 1.00;
	if (frameRight.onLayout) frameRight.onLayout();
	const frameLeft = this.frameLeft;
	ch5_p12_hh_ch5_72dpi_p012psdAssetch5_p12_wcframeLframe.call(this.frameLeft);
	frameLeft.x = 0;
	frameLeft.y = 384;
	frameLeft.width = 344.00;
	frameLeft.height = 768.00;
	frameLeft.alpha = 1.00;
	if (frameLeft.onLayout) frameLeft.onLayout();
	return this;
}
function ch5_p12_hh_ch5_72dpi_p012psdAssetch5_p12_bg(this: Ich5_p12_hh_ch5_72dpi_p012psdAssetch5_p12_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch5_p12_bg", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p12_hh_ch5_72dpi_p012psdAssetch5_p12_hollyhorse(this: Ich5_p12_hh_ch5_72dpi_p012psdAssetch5_p12_hollyhorse) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch5_p12_hollyhorse", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p12_hh_ch5_72dpi_p012psdAssetch5_p12_balloon1(this: Ich5_p12_hh_ch5_72dpi_p012psdAssetch5_p12_balloon1) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch5_p12_balloon1", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p12_hh_ch5_72dpi_p012psdAssetch5_p12_balloon2(this: Ich5_p12_hh_ch5_72dpi_p012psdAssetch5_p12_balloon2) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch5_p12_balloon2", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p12_hh_ch5_72dpi_p012psdAssetch5_p12_balloon3(this: Ich5_p12_hh_ch5_72dpi_p012psdAssetch5_p12_balloon3) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch5_p12_balloon3", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p12_hh_ch5_72dpi_p012psdAssetch5_p12_balloon4(this: Ich5_p12_hh_ch5_72dpi_p012psdAssetch5_p12_balloon4) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch5_p12_balloon4", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p12_hh_ch5_72dpi_p012psdAssetch5_p12_actionlines(this: Ich5_p12_hh_ch5_72dpi_p012psdAssetch5_p12_actionlines) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch5_p12_actionlines", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p12_hh_ch5_72dpi_p012psdAssetch5_p12_wcframeRframe(this: Ich5_p12_hh_ch5_72dpi_p012psdAssetch5_p12_wcframeRframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Rframe", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch5_p12_hh_ch5_72dpi_p012psdAssetch5_p12_wcframeLframe(this: Ich5_p12_hh_ch5_72dpi_p012psdAssetch5_p12_wcframeLframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Lframe", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
interface Ich5_p12Array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface Ich5_p12Container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface Ich5_p12Sprite extends Ich5_p12Container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
	alpha: number;
	setBlendMode?(blendMode: string): void;
}
interface Ich5_p12Text extends Ich5_p12Container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface Ich5_p12Polygon extends Array<number> {
}
interface Ich5_p12 {
	readonly balloon: Ich5_p12Array<Ich5_p12_hh_ch5_72dpi_p012psdAssetch5_p12_balloon1|Ich5_p12_hh_ch5_72dpi_p012psdAssetch5_p12_balloon2|Ich5_p12_hh_ch5_72dpi_p012psdAssetch5_p12_balloon3|Ich5_p12_hh_ch5_72dpi_p012psdAssetch5_p12_balloon4>;
	readonly bg: Ich5_p12_hh_ch5_72dpi_p012psdAssetch5_p12_bg;
	readonly hollyHorse: Ich5_p12_hh_ch5_72dpi_p012psdAssetch5_p12_hollyhorse;
	readonly actionLines: Ich5_p12_hh_ch5_72dpi_p012psdAssetch5_p12_actionlines;
	readonly frameRight: Ich5_p12_hh_ch5_72dpi_p012psdAssetch5_p12_wcframeRframe;
	readonly frameLeft: Ich5_p12_hh_ch5_72dpi_p012psdAssetch5_p12_wcframeLframe;
}
interface Ich5_p12_hh_ch5_72dpi_p012psdAssetch5_p12_bg extends Ich5_p12Sprite {
}
interface Ich5_p12_hh_ch5_72dpi_p012psdAssetch5_p12_hollyhorse extends Ich5_p12Sprite {
}
interface Ich5_p12_hh_ch5_72dpi_p012psdAssetch5_p12_balloon1 extends Ich5_p12Sprite {
}
interface Ich5_p12_hh_ch5_72dpi_p012psdAssetch5_p12_balloon2 extends Ich5_p12Sprite {
}
interface Ich5_p12_hh_ch5_72dpi_p012psdAssetch5_p12_balloon3 extends Ich5_p12Sprite {
}
interface Ich5_p12_hh_ch5_72dpi_p012psdAssetch5_p12_balloon4 extends Ich5_p12Sprite {
}
interface Ich5_p12_hh_ch5_72dpi_p012psdAssetch5_p12_actionlines extends Ich5_p12Sprite {
}
interface Ich5_p12_hh_ch5_72dpi_p012psdAssetch5_p12_wcframeRframe extends Ich5_p12Sprite {
}
interface Ich5_p12_hh_ch5_72dpi_p012psdAssetch5_p12_wcframeLframe extends Ich5_p12Sprite {
}
